import styled, { css } from 'styled-components'
import {
    ExtraSmallButtonText,
    SmallButtonText
} from 'app-v2/design-systems/typography/text'

const buttonCss = css`
    cursor: ${props => (props.disabled ? 'initial' : 'pointer')};
    border: ${props =>
        props.variant === 'text' ? 'none' : `2px solid ${props.color}`};
    border-radius: ${props => props.borderRadius}px;
    background: ${props =>
        props.variant === 'contained' ? props.color : 'transparent'};
    ${props => props.fullLength && 'width: 100%'}
`

export const ButtonContainer = styled.button`
    ${buttonCss}
`

export const ButtonLinkContainer = styled.a`
    ${buttonCss}
`

export const LabelContainer = styled(SmallButtonText)`
    text-align: center;
    padding: 14px 24px;
    color: ${props => props.color};
`

export const SmallLabelContainer = styled(ExtraSmallButtonText)`
    text-align: center;
    padding: 7px 16px;
    color: ${props => props.color};
`

export const IconText = styled.div`
    display: flex;
    align-items: center;
`
